import React from 'react';

import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';

import { employeeAssignmentErrorColumnWidths as W } from './columnWidths';
import {
  FailedTaskAssignmentRow,
  getAssignmentErrorMessage
} from './lib/assignmentErrors';

interface AutoEmployeeAssignmentErrorsTableProps {
  rows: FailedTaskAssignmentRow[];
}

const AutoEmployeeAssignmentErrorsTable: React.FC<
  AutoEmployeeAssignmentErrorsTableProps
> = ({ rows }) => {
  if (rows.length === 0) return null;

  const errorBody = (rowData: FailedTaskAssignmentRow) => (
    <div>
      {rowData.errors.map((error, index) => (
        <div key={index}>{getAssignmentErrorMessage(error)}</div>
      ))}
    </div>
  );

  return (
    <div className="flex flex-column gap-2 mt-3">
      <span className="font-medium">
        Наряды, которые не удалось распределить
      </span>
      <DataTable
        size="small"
        value={rows}
        scrollable
        scrollHeight="200px"
        emptyMessage="Нет данных"
      >
        <Column
          field="taskId"
          header="Номер наряда"
          style={{ width: W.taskId }}
        />
        <Column
          field="taskTypeLabel"
          header="Тип наряда"
          style={{ width: W.taskType }}
        />
        <Column
          header="Текст ошибки"
          body={errorBody}
          style={{ width: W.error }}
        />
      </DataTable>
    </div>
  );
};

export default AutoEmployeeAssignmentErrorsTable;
